export default "__VITE_PUBLIC_ASSET__1d8c53f7__"